module.exports = __webpack_public_path__ + "static/smokescreen-logo-f606450260a1831d21f48df2d700f7ab.png";